import styled from 'styled-components';

import { BREAK_POINTS } from '../../consts/styleDedupe';
import { COLOURS } from '../../consts/style';

export const CardContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  flex-direction: row-reverse;

  @media (min-width: ${BREAK_POINTS.Min.LG}) {
    flex-direction: column;
  }
`;

export const ImageContainer = styled.div`
  padding-left: 32px;
  & > img {
    width: 72px;
  }

  @media (min-width: ${BREAK_POINTS.Min.LG}) {
    padding-left: 0;
    & > img {
      width: inherit;
      height: 102px;
    }
  }
`;

export const TextContainer = styled.div`
  @media (min-width: ${BREAK_POINTS.Min.MD}) {
    box-sizing: border-box;
    width: 648px;
  }

  @media (min-width: ${BREAK_POINTS.Min.LG}) {
    width: inherit;
    padding-right: 0;
  }

  & > [data-id='why-origin-heading'] {
    color: ${COLOURS.TEXT.HEADING};
    margin-top: 0;

    @media (min-width: ${BREAK_POINTS.Min.LG}) {
      margin-top: 24px;
    }
  }

  & > div[data-id='why-origin-text'] {
    margin-bottom: 16px;

    // faux link
    & b {
      font-weight: normal;
      text-decoration: underline;
    }

    @media (min-width: ${BREAK_POINTS.Min.LG}) {
      margin-bottom: 24px;
    }
  }
`;
